export const dialogTheme = {
  root: {
    borderRadius: 'var(--border-radius)',
  },
  title: {
    fontSize: 'var(--font-size-4xl)',
    fontWeight: 'var(--font-weight-500)',
  },
  header: {
    padding:
      'var(--one-half-rem) var(--one-half-rem) var(--half-rem) var(--one-half-rem)',
  },
  content: {
    padding:
      'var(--quarter-rem) var(--one-half-rem) var(--one-half-rem) var(--one-half-rem)',
  },
  footer: {
    padding:
      'var(--reset) var(--one-half-rem) var(--one-half-rem) var(--one-half-rem)',
  },
  colorScheme: {
    light: {
      root: {
        background: 'var(--p-white)',
        color: 'var(--text-color)',
        shadow: 'var(--dialog-box-shadow)',
      },
    },
    dark: {
      root: {
        background: 'var(--secondary-background)',
        color: 'var(--text-color)',
        shadow: 'var(--dialog-box-shadow)',
      },
    },
  },
  css: () => `
  .p-dialog .p-dialog-header .p-dialog-close-button [data-p-icon] {
    height: var(--one-quarter-rem);
    width: var(--one-quarter-rem);
  }
  `,
};
